import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '../services/global.service';

@Pipe({
    name: 'backTranslate',
    standalone: false
})
export class BackTranslatePipe implements PipeTransform {

	constructor(private _gS: GlobalService) { }

	transform(item, value, textDefault?): boolean {
		return this._gS.backTranslate(item, value, textDefault);
	}

}
